<template>
    <ui-modal>
        <template #header>
            <h3 v-text="title" class="text-center mb-0" />
        </template>
        <div class="text-center p-3">
            <a-icon :icon="icon" width="2.5rem" height="2.5rem" />
            <h5 v-if="details" v-html="details" class="text-center font-weight-normal my-3" />
            <component
                v-if="args.component"
                :is="args.component"
                v-bind="args.props"
            />
        </div>

        <template v-if="rejectBtn || acceptBtn" #footer>
            <the-btn
                v-if="rejectBtn"
                class="btn-outline-custom"
                :text="rejectBtn.text"
                @click="rejectBtn.onRejectBtn"
            />
            <the-btn
                v-if="acceptBtn"
                class="btn-secondary"
                :text="acceptBtn.text"
                @click="acceptBtn.onAcceptBtn"
            />
        </template>
    </ui-modal>
</template>

<script>

const statusIcons = {
    ok: 'Ok',
    error: 'ErrorCircle'
}

const defaultText = {
    ok: 'Świetnie!',
    error: 'Wystąpił błąd!'
}

export default {
    provide() {
        return {
            closeModal: this.closeModal
        }
    },

    computed: {
        args() {
            return this.$store.getters.modalState.args
        },
        title() {
            return this.args.title || defaultText[this.args.status]
        },
        icon() {
            return statusIcons[this.args.status]
        },
        details() {
            return this.args.details
        },
        rejectBtn() {
            return this.args.rejectBtn
        },
        acceptBtn() {
            return this.args.acceptBtn
        },
        closeModal() {
            return this.args.closeModal
        }
    }
}
</script>